import type { IResourcesSectionModel } from "@/models/compute-resource.model";

export const computeResourceUtil = {
  computeResourceUISummary,
};

function computeResourceUISummary(resourcesModel: IResourcesSectionModel): string {
  return `GPU Devices: ${resourcesModel.gpuDevicesRequest || 0} / GPU Memory: ${_gpuSummary(
    resourcesModel,
  )} / CPU Compute: ${resourcesModel.cpuCore.request} Cores / CPU Memory: ${resourcesModel.cpuMemory.request}`;
}

function _gpuSummary(resourcesModel: IResourcesSectionModel): string | number {
  const { gpuPortionRequest, gpuMemoryRequest, migProfile } = resourcesModel;
  if (gpuPortionRequest != null && gpuPortionRequest != undefined) {
    return `${gpuPortionRequest * 100}%`;
  }
  if (gpuMemoryRequest != null && gpuMemoryRequest != undefined) {
    return `${gpuMemoryRequest}B`;
  }
  if (migProfile != null && migProfile != undefined) {
    return migProfile;
  }
  return "None";
}
